import { render } from "./KeyboardF3.vue?vue&type=template&id=1498a150"
import script from "./KeyboardF3.vue?vue&type=script&lang=js"
export * from "./KeyboardF3.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1498a150"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1498a150', __exports__)) {
    api.reload('1498a150', __exports__)
  }
  
  module.hot.accept("./KeyboardF3.vue?vue&type=template&id=1498a150", () => {
    api.rerender('1498a150', render)
  })

}


export default __exports__